import React, { useEffect, useState } from 'react';
import { Info } from 'lucide-react';
import { api } from '../lib/api';
import { t } from '../lib/i18n';

let cache = null;
let pending = null;
const load = () => (pending ||= api.get('/settings/demo-notice').then((r) => (cache = r.data)).catch(() => (cache = { enabled: false })));

export const setDemoNotice = (data) => { cache = data; pending = Promise.resolve(data); window.dispatchEvent(new Event('dealgo:demo-notice')); };

export const useDemoNotice = () => {
  const [notice, setNotice] = useState(cache);
  useEffect(() => {
    if (!cache) load().then(setNotice);
    const onChange = () => setNotice(cache);
    window.addEventListener('dealgo:demo-notice', onChange);
    return () => window.removeEventListener('dealgo:demo-notice', onChange);
  }, []);
  return notice;
};

// Thin, always-visible bar at the top of every page while the site shows demo content.
export const DemoNotice = () => {
  const notice = useDemoNotice();
  if (!notice?.enabled) return null;
  const text = notice.text_en;
  return (
    <div role="note" className="relative z-[60] bg-[#FFD60A] text-black px-3 py-1.5 text-center text-[11px] sm:text-xs font-semibold leading-snug flex items-center justify-center gap-1.5" data-testid="demo-notice">
      <Info size={13} className="shrink-0" /> <span>{text}</span>
    </div>
  );
};

// Small reminder pill shown inside the catalog reader (normal and full screen).
export const ReaderDemoNotice = ({ fullscreen }) => {
  const notice = useDemoNotice();
  if (!notice?.enabled) return null;
  return (
    <div className={`absolute left-1/2 -translate-x-1/2 z-30 pointer-events-none whitespace-nowrap px-2.5 py-0.5 rounded-full bg-[#FFD60A] text-black text-[10px] font-bold uppercase tracking-wide shadow ${fullscreen ? 'top-14' : 'top-1.5 md:top-3'}`} data-testid="reader-demo-notice">
      {t('Catalogue de démonstration — offres fictives')}
    </div>
  );
};

export default DemoNotice;
